import getSymbolFromCurrency from 'currency-symbol-map'

document.addEventListener("calpak:loaded", async function () {
    const orderSummaries = document.querySelectorAll(".order-summary");
    if (orderSummaries?.length) {
        orderSummaries.forEach((orderSummary) => {
            if (orderSummary) {
                const currencyCode = orderSummary?.getAttribute("data-currency");
                const currencySymbolDiv = orderSummary?.querySelector(".order-total-line .order-currency-symbol");
                const currencySymbol = getSymbolFromCurrency(currencyCode);
                if (currencySymbolDiv) currencySymbolDiv.innerHTML = currencySymbol;
            }
        })
    }
});
